import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

interface QuestionsLoanTypesCardSignature {
  Args: {
    icon?: ComponentLike<{ Args: { size?: string | number } }>;
    imageAlt?: string;
    label: string;
    src?: string;
  };
  Element: HTMLDivElement;
}

const QuestionsLoanTypesCardComponent: TOC<QuestionsLoanTypesCardSignature> = <template>
  <div class="text-center p-5 border-b border-gray-200" ...attributes>
    {{#if @icon}}
      <div class="mx-auto mb-4 flex items-center justify-center h-12 w-12 text-cyan-600">
        <@icon @size="42" />
      </div>
    {{else if @src}}
      <img class="mx-auto mb-4 h-12 w-12" alt={{@imageAlt}} src={{@src}} />
    {{/if}}
    <span class="block">{{@label}}</span>
  </div>
</template>;

export default QuestionsLoanTypesCardComponent;
